export default class Price {
    constructor(country, locale) {
        this.country = country
        this.locale = locale
    }

    getPriceAndCurrency(price) {
        let currency = this.getCurrency()
        let value = price[currency.toLowerCase()]

        if (value == null) {
            currency = "USD"
            value = price.usd
        }

        return {
            price: value / 100,
            currency: currency
        }
    }

    getCurrency() {
        if (this.country === "Serbia") return "RSD"
        
        return "USD"
    }
}